import React, { useEffect, useState } from 'react';
import { FiDownload as DownloadIcon } from 'react-icons/fi';
import PaymentServices from '../services/externalServices/TicketServices/paymentServicesV2';
import ticketicon from "../../assets/images/Ticket-icon.png"
import purchaseCost from "../../assets/images/PurchaseCost.png"
import movieicon from "../../assets/images/movie-icon.png"
import showicon from "../../assets/images/show-icon.png"
import revenueicon from "../../assets/images/revenue.png"

// const TicketDashboard = () => {
//   const [ticketData, setTicketData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState('');
//   const [orderBy, setOrderBy] = useState('bookingDate');
//   const [order, setOrder] = useState('desc');
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(50);
//   const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin"));

//   // Filter states
//   const [dateRange, setDateRange] = useState({
//     start: null,
//     end: null
//   });
//   const [showTimeFilter, setShowTimeFilter] = useState('');
//   const [movieFilter, setMovieFilter] = useState('');
//   const [theatreFilter, setTheatreFilter] = useState('');
//   const [paymentMethodFilter, setPaymentMethodFilter] = useState('');
//   const [statusFilter, setStatusFilter] = useState('');
//   const [showDateFilter, setShowDateFilter] = useState('');

//   const isTicketAdmin = role === 'ticket-admin';
//   const theatreName = accessList?.[0];

//   const fetchTicketData = async () => {
//     try {
//       const response = await PaymentServices.getDetailReports1({ theatreName });
//       const items = response.data || [];
//       setTicketData(items);
//       setFilteredData(items);
//       setLoading(false);
//     } catch (err) {
//       console.error('Error fetching ticket data:', err);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchTicketData();
//   }, []);

//   // Apply all filters
//   useEffect(() => {
//     let filtered = [...ticketData];

//     // Text search filter
//     if (search) {
//       const lowerSearch = search.toLowerCase();
//       filtered = filtered.filter(
//         t => t.movieName.toLowerCase().includes(lowerSearch) ||
//           t.theatreName.toLowerCase().includes(lowerSearch) ||
//           t.transactionStatus.toLowerCase().includes(lowerSearch)
//       );
//     }

//     // Date range filter
//     // if (dateRange.start && dateRange.end) {
//     //   filtered = filtered.filter(t => {
//     //     const bookingDate = new Date(t.bookingDate);
//     //     return bookingDate >= new Date(dateRange.start) &&
//     //       bookingDate <= new Date(dateRange.end);
//     //   });
//     // }

//     if (dateRange.start && dateRange.end) {
//       filtered = filtered.filter(t => {
//         const bookingDate = new Date(t.bookingDate);
//         const startDate = new Date(dateRange.start);
//         startDate.setHours(0, 0, 0, 0); // Start of the day (00:00:00.000)

//         const endDate = new Date(dateRange.end);
//         endDate.setHours(23, 59, 59, 999); // End of the day (23:59:59.999)

//         return bookingDate >= startDate && bookingDate <= endDate;
//       });
//     }

//     // Show time filter
//     if (showTimeFilter) {
//       filtered = filtered.filter(t => t.showTime === showTimeFilter);

//     }

//     // Movie filter
//     if (movieFilter) {
//       filtered = filtered.filter(t => t.movieName === movieFilter);
//     }

//     // Theatre filter
//     if (theatreFilter) {
//       filtered = filtered.filter(t => t.theatreName === theatreFilter);
//     }

//     // Payment method filter
//     if (paymentMethodFilter) {
//       filtered = filtered.filter(t => t.paymentMethod === paymentMethodFilter);
//     }

//     // Status filter
//     if (statusFilter) {
//       filtered = filtered.filter(t => t.transactionStatus === statusFilter);
//     }


//     // Show date filter
//     if (showDateFilter) {
//       filtered = filtered.filter(t => t.showDate === showDateFilter);
//     }

//     setFilteredData(filtered);
//     setPage(0);
//   }, [
//     search,
//     ticketData,
//     dateRange,
//     showTimeFilter,
//     movieFilter,
//     theatreFilter,
//     paymentMethodFilter,
//     statusFilter,
//     showDateFilter
//   ]);

//   // Get unique values for dropdown filters
//   const uniqueValues = (field) => {
//     return [...new Set(ticketData.map(item => item[field]))].filter(Boolean).sort();
//   };

//   const handleSort = (field) => {
//     const isAsc = orderBy === field && order === 'asc';
//     setOrder(isAsc ? 'desc' : 'asc');
//     setOrderBy(field);
//   };

//   const sortedData = [...filteredData].sort((a, b) => {
//     if (a[orderBy] < b[orderBy]) return order === 'asc' ? -1 : 1;
//     if (a[orderBy] > b[orderBy]) return order === 'asc' ? 1 : -1;
//     return 0;
//   });

//   const paginatedData = sortedData.slice(
//     page * rowsPerPage,
//     page * rowsPerPage + rowsPerPage
//   );

//   const exportCSV = () => {
//     const headers = [
//       'Movie', 'Theatre', 'Show Date', 'Show Time', 'Seats',
//       'Amount', 'Payment Method', 'Payment Mode', 'Transaction ID',
//       'PaymentStatus', 'Booking Date'
//     ];
//     const rows = ticketData.map(t => [
//       t.movieName, t.theatreName, t.showDate, t.showTime,
//       t.bookedSeats.join(', '), t.totalAmount, t.paymentMethod,
//       t.paymentMode, t.transactionId, t.transactionStatus, t.bookingDate
//     ]);
//     const csv = [headers, ...rows].map(r => r.join(',')).join('\n');

//     const blob = new Blob([csv], { type: 'text/csv' });
//     const link = document.createElement('a');
//     link.href = window.URL.createObjectURL(blob);
//     link.download = 'TicketReport.csv';
//     link.click();
//   };

//   const clearFilters = () => {
//     setSearch('');
//     setDateRange({ start: null, end: null });
//     setShowTimeFilter('');
//     setMovieFilter('');
//     setTheatreFilter('');
//     setPaymentMethodFilter('');
//     setStatusFilter('');
//     setShowDateFilter(''); // Add this line
//   };


//   const calculateMetrics = (data) => {

//     console.log('data purchase cost', data[0]?.purchaseCost)
//     if (data.length === 0) {
//       return {
//         totalTickets: 0,
//         totalRevenue: 0,
//         totalRevenue: 0,
//         mostPopularShowTime: 'N/A',
//         mostPopularMovie: 'N/A',
//         filteredMovie: null,
//         showTimeFilter: null // Add this
//       };
//     }

//     const totalTickets = data.reduce((sum, ticket) => sum + ticket.bookedSeats.length, 0);
//     const totalRevenue = data.reduce((sum, ticket) => sum + (ticket.totalAmount || 0), 0);



//     const uniqueMovieTheatrePairs = new Map();

//     data.forEach(ticket => {
//       const key = `${ticket.movieName}-${ticket.theatreName}`;
//       if (!uniqueMovieTheatrePairs.has(key) && ticket.purchaseCost) {
//         uniqueMovieTheatrePairs.set(key, ticket.purchaseCost);
//       }
//     });

//     const avgPaymentCost = [...uniqueMovieTheatrePairs.values()].reduce((sum, cost) => sum + cost, 0);



//     // Check if we're filtering by a specific movie
//     const uniqueMovies = [...new Set(data.map(item => item.movieName))];
//     const filteredMovie = uniqueMovies.length === 1 ? uniqueMovies[0] : null;




//     const showTimeCounts = data.reduce((acc, ticket) => {
//       acc[ticket.showTime] = (acc[ticket.showTime] || 0) + ticket.bookedSeats.length;
//       return acc;
//     }, {});

//     const mostPopularShowTime = Object.entries(showTimeCounts)
//       .sort((a, b) => b[1] - a[1])[0]?.[0] || 'N/A';

//     // Only calculate popular movie if not filtered by a specific movie
//     let mostPopularMovie = 'N/A';
//     if (!filteredMovie) {
//       const movieCounts = data.reduce((acc, ticket) => {
//         acc[ticket.movieName] = (acc[ticket.movieName] || 0) + ticket.bookedSeats.length;
//         return acc;
//       }, {});

//       mostPopularMovie = Object.entries(movieCounts)
//         .sort((a, b) => b[1] - a[1])[0]?.[0] || 'N/A';
//     }

//     return {
//       totalTickets,
//       totalRevenue,
//       mostPopularShowTime,
//       mostPopularMovie,
//       filteredMovie,
//       avgPaymentCost,
//       showTimeFilter // Add this to the returned object
//     };
//   };



//   const SummaryCards = ({ data }) => {
//     const metrics = calculateMetrics(data);

//     console.log('metrics', metrics)

//     return (
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6 py-2 px-1">
//         {/* Total Payment Cost Card */}
//         <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-blue-500">
//           <div className="p-3 bg-blue-50 rounded-full">
//             <img src={purchaseCost} alt='payment' className='w-10 h-10' />
//           </div>
//           <div className="flex-1 min-w-0">
//             <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Total Payment Cost</h3>
//             <p className="text-2xl font-bold my-1 text-gray-800 truncate">
//               ₹{typeof metrics.avgPaymentCost === 'number'
//                 ? metrics.avgPaymentCost.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
//                 : '0.00'}
//             </p>
//             <p className="text-gray-400 text-xs">Purchase cost of movie</p>
//           </div>
//         </div>

//         {/* Total Tickets Card */}
//         <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-green-500">
//           <div className="p-3 bg-yellow-50 rounded-full">
//             <img src={ticketicon} alt='tickets' className='w-10 h-10' />
//           </div>
//           <div className="flex-1 min-w-0">
//             <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Total Tickets</h3>
//             <p className="text-2xl font-bold my-1 text-gray-800">{metrics.totalTickets}</p>
//             <p className="text-gray-400 text-xs">Booked seats</p>
//           </div>
//         </div>

//         {/* Total Revenue Card */}
//         <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-purple-500">
//           <div className="p-3 bg-blue-50 rounded-full">
//             <img src={revenueicon} alt='revenue' className='w-10 h-10' />
//           </div>
//           <div className="flex-1 min-w-0">
//             <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Total Revenue</h3>
//             <p className="text-2xl font-bold my-1 text-gray-800">
//               ₹{metrics.totalRevenue.toLocaleString('en-IN')}
//             </p>
//             <p className="text-gray-400 text-xs">Total collected</p>
//           </div>
//         </div>

//         {/* Popular Show Time Card */}
//         {/* <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-yellow-500">
//           <div className="p-3 bg-purple-50 rounded-full">
//             <img src={showicon} alt='show' className='w-10 h-10' />
//           </div>
//           <div className="flex-1 min-w-0">
//             <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Popular Show</h3>
//             <p className="text-2xl font-bold my-1 text-gray-800 truncate">
//               {metrics.mostPopularShowTime || 'N/A'}
//             </p>
//             <p className="text-gray-400 text-xs">Most booked time</p>
//           </div>
//         </div> */}






//         {metrics.showTimeFilter ? (
//           <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-yellow-500">
//             <div className="p-3 bg-purple-50 rounded-full">
//               <img src={showicon} alt='show' className='w-10 h-10' />
//             </div>
//             <div className="flex-1 min-w-0">
//               <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Selected Show</h3>
//               <p className="text-xl font-bold my-1 text-gray-800 truncate">
//                 {metrics.showTimeFilter}
//               </p>
//               <p className="text-gray-400 text-xs">Current filter</p>
//             </div>
//           </div>
//         ) : (
//           <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-yellow-500">
//             <div className="p-3 bg-red-50 rounded-full">
//               <img src={movieicon} alt='movie' className='w-10 h-10' />
//             </div>
//             <div className="flex-1 min-w-0">
//               <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Popular Show</h3>
//               <p className="text-xl font-bold my-1 text-gray-800 truncate">
//                 {metrics.mostPopularShowTime}
//               </p>
//               <p className="text-gray-400 text-xs">Most booked time</p>
//             </div>
//           </div>
//         )}

//         {/* Movie Card (Conditional) */}
//         {metrics.filteredMovie ? (
//           <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-indigo-500">
//             <div className="p-3 bg-red-50 rounded-full">
//               <img src={movieicon} alt='movie' className='w-10 h-10' />
//             </div>
//             <div className="flex-1 min-w-0">
//               <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Selected Movie</h3>
//               <p className="text-xl font-bold my-1 text-gray-800 truncate">
//                 {metrics.filteredMovie}
//               </p>
//               <p className="text-gray-400 text-xs">Current filter</p>
//             </div>
//           </div>
//         ) : (
//           <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-indigo-500">
//             <div className="p-3 bg-red-50 rounded-full">
//               <img src={movieicon} alt='movie' className='w-10 h-10' />
//             </div>
//             <div className="flex-1 min-w-0">
//               <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Popular Movie</h3>
//               <p className="text-xl font-bold my-1 text-gray-800 truncate">
//                 {metrics.mostPopularMovie || 'N/A'}
//               </p>
//               <p className="text-gray-400 text-xs">Most booked film</p>
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   };

//   const formatDateToDDMMYYYY = (dateInput) => {
//     if (!dateInput) return '';

//     // Handle both string dates and Date objects
//     const date = dateInput instanceof Date ? dateInput : new Date(dateInput);

//     // Check if the date is valid
//     if (isNaN(date.getTime())) return 'Invalid date';

//     const day = String(date.getDate()).padStart(2, '0');
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const year = date.getFullYear();

//     return `${day}-${month}-${year}`;
//   };

//   return (
//     <div className="md:max-w-5xl mx-auto mb-4">
//       <div className=''>
//         <div className="flex justify-between items-center mb-4 ">
//           <h2 className="text-3xl font-semibold">Ticket Summary </h2>
//           <button
//             onClick={exportCSV}
//             className="flex items-center bg-black text-white px-4 py-2 rounded hover:bg-gray-800 transition-colors"
//           >
//             <DownloadIcon className="h-5 w-5 mr-2" />
//             Export CSV
//           </button>
//         </div>

//         {/* {!loading && ticketData.length > 0 && (
//         <SummaryCards data={ticketData} />
//       )} */}



//     {/* Filter Section */}
//     <div className="bg-white rounded-lg shadow p-4 mb-6">
//           <h3 className="text-lg font-medium mb-3">Filters</h3>
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
//             {/* General Search */}
//             {/* <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">Search</label>
//             <input
//               type="text"
//               className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//             />
//           </div> */}

//             {/* Date Range */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Booking From Date</label>
//               <input
//                 type="date"
//                 className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
//                 value={dateRange.start || ''}
//                 onChange={(e) => setDateRange({ ...dateRange, start: e.target.value })}
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Booking To Date</label>
//               <input
//                 type="date"
//                 className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
//                 value={dateRange.end || ''}
//                 onChange={(e) => setDateRange({ ...dateRange, end: e.target.value })}
//               />
//             </div>

//             {/* Show Time */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Show Time</label>
//               <select
//                 className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
//                 value={showTimeFilter}
//                 onChange={(e) => setShowTimeFilter(e.target.value)}
//               >
//                 <option value="">All</option>
//                 {uniqueValues('showTime').map(time => (
//                   <option key={time} value={time}>{time}</option>
//                 ))}
//               </select>
//             </div>
//             {/* Show Date */}

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Show Date</label>
//               <select
//                 className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
//                 value={showDateFilter}
//                 onChange={(e) => setShowDateFilter(e.target.value)}
//               >
//                 <option value="">All</option>
//                 {uniqueValues('showDate').map(date => (
//                   <option key={date} value={date}>{date}</option>
//                 ))}
//               </select>
//             </div>

//             {/* Movie */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Movie</label>
//               <select
//                 className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
//                 value={movieFilter}
//                 onChange={(e) => setMovieFilter(e.target.value)}
//               >
//                 <option value="">All</option>
//                 {uniqueValues('movieName').map(movie => (
//                   <option key={movie} value={movie}>{movie}</option>
//                 ))}
//               </select>
//             </div>

//             {/* Theatre */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Theatre</label>
//               <select
//                 className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
//                 value={theatreFilter}
//                 onChange={(e) => setTheatreFilter(e.target.value)}
//               >
//                 <option value="">All</option>
//                 {uniqueValues('theatreName').map(theatre => (
//                   <option key={theatre} value={theatre}>{theatre}</option>
//                 ))}
//               </select>
//             </div>

//             {/* Payment Method */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Payment Method</label>
//               <select
//                 className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
//                 value={paymentMethodFilter}
//                 onChange={(e) => setPaymentMethodFilter(e.target.value)}
//               >
//                 <option value="">All</option>
//                 {uniqueValues('paymentMethod').map(method => (
//                   <option key={method} value={method}>{method}</option>
//                 ))}
//               </select>
//             </div>

//             {/* Status */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
//               <select
//                 className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
//                 value={statusFilter}
//                 onChange={(e) => setStatusFilter(e.target.value)}
//               >
//                 <option value="">All</option>
//                 {uniqueValues('transactionStatus').map(status => (
//                   <option key={status} value={status}>{status}</option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           <button
//             className="mt-4 px-4 py-2 border bg-red-500 border-gray-300 rounded-md hover:bg-red-600 text-white transition-colors"
//             onClick={clearFilters}
//           >
//             Clear All Filters
//           </button>
//         </div>
//         {!loading && filteredData.length > 0 && (
//           <SummaryCards data={filteredData} />
//         )}



//         {/* Results Section */}
//         {loading ? (
//           <div className="flex justify-center items-center h-24">
//             <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-black"></div>
//           </div>
//         ) : filteredData.length === 0 ? (
//           <div className="text-center py-12">
//             <div className="mx-auto h-24 w-24 text-gray-400">
//               <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//               </svg>
//             </div>
//             <h3 className="mt-2 text-lg font-medium text-gray-700">No tickets found</h3>
//             <p className="mt-1 text-gray-500">Try adjusting your search or filter criteria</p>
//           </div>
//         ) : (
//           <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
//             <div className="overflow-x-auto">
//               <table className="min-w-full divide-y divide-gray-200">
//                 <thead className="bg-black">
//                   <tr>
//                     {[
//                       { label: 'Booking Date', field: 'bookingDate' },
//                       { label: 'Show Time', field: 'showTime' },
//                       { label: 'Movie', field: 'movieName' },
//                       { label: 'Theatre', field: 'theatreName' },
//                       { label: 'Seats', field: 'bookedSeats' },
//                       { label: 'Show Date', field: 'showDate' },
//                       { label: 'Amount', field: 'totalAmount' },
//                       { label: 'Payment Method', field: 'paymentMethod' },
//                       { label: 'Payment Mode', field: 'paymentMode' },
//                       { label: 'Transaction ID', field: 'transactionId' },
//                       { label: 'Status', field: 'transactionStatus' },
//                     ].map((col) => (
//                       <th
//                         key={col.field}
//                         scope="col"
//                         className="px-6 py-4 text-left text-xs font-semibold text-gray-100 uppercase tracking-wider cursor-pointer hover:bg-gray-700 transition-colors duration-150"
//                         onClick={() => handleSort(col.field)}
//                       >
//                         <div className="flex items-center">
//                           {col.label}
//                           {orderBy === col.field && (
//                             <span className="ml-2">
//                               {order === 'asc' ? (
//                                 <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
//                                 </svg>
//                               ) : (
//                                 <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
//                                 </svg>
//                               )}
//                             </span>
//                           )}
//                         </div>
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>

//                 <tbody className="bg-white divide-y divide-gray-200">
//                   {paginatedData.map((t, idx) => (
//                     <tr key={idx} className="hover:bg-gray-50 transition-colors duration-150">
//                       <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
//                         {formatDateToDDMMYYYY(t.bookingDate)}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
//                         <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded-full text-xs font-medium">
//                           {t.showTime}
//                           {/* {t.showTime} */}
//                         </span>
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-900">
//                         {t.movieName}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
//                         {t.theatreName}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
//                         <div className="flex flex-wrap gap-1 max-w-xs">
//                           {t.bookedSeats.map((seat, i) => (
//                             <span key={i} className="px-2 py-1 bg-gray-100 text-gray-800 rounded text-xs">
//                               {seat}
//                             </span>
//                           ))}
//                         </div>
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
//                         {t.showDate}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm font-semibold text-green-600">
//                         ₹{t.totalAmount}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
//                         {t.paymentMethod}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
//                         {t.paymentMode}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600 font-mono">
//                         {t.transactionId}
//                       </td>
//                       <td className="px-4 py-3 whitespace-nowrap">
//                         <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${t.transactionStatus === 'success'
//                           ? 'bg-red-100 text-red-800'
//                           : t.transactionStatus === 'pending'
//                             ? 'bg-yellow-100 text-yellow-800'
//                             : 'bg-green-100 text-green-800'
//                           }`}>
//                           {t.transactionStatus}
//                         </span>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination */}
//             {/* <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between">
//               <div className="flex-1 flex justify-between sm:hidden">
//                 <button
//                   onClick={() => setPage(Math.max(0, page - 1))}
//                   disabled={page === 0}
//                   className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
//                 >
//                   Previous
//                 </button>
//                 <button
//                   onClick={() => setPage(Math.min(Math.ceil(filteredData.length / rowsPerPage) - 1, page + 1))}
//                   disabled={page >= Math.ceil(filteredData.length / rowsPerPage) - 1}
//                   className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
//                 >
//                   Next
//                 </button>
//               </div>
//               <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
//                 <div>
//                   <p className="text-sm text-gray-700">
//                     Showing <span className="font-medium">{page * rowsPerPage + 1}</span> to{' '}
//                     <span className="font-medium">
//                       {Math.min((page + 1) * rowsPerPage, filteredData.length)}
//                     </span>{' '}
//                     of <span className="font-medium">{filteredData.length}</span> results
//                   </p>
//                 </div>
//                 <div className="flex items-center space-x-4">
//                   <div className="flex items-center">
//                     <p className="text-sm text-gray-700 mr-2">Rows per page:</p>
//                     <select
//                       className="border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                       value={rowsPerPage}
//                       onChange={(e) => {
//                         setRowsPerPage(parseInt(e.target.value, 10));
//                         setPage(0);
//                       }}
//                     >
//                       {[100, 200].map((size) => (
//                         <option key={size} value={size}>
//                           {size}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
//                     <button
//                       onClick={() => setPage(Math.max(0, page - 1))}
//                       disabled={page === 0}
//                       className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
//                     >
//                       <span className="sr-only">Previous</span>
//                       <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
//                         <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
//                       </svg>
//                     </button>
//                     {Array.from({ length: Math.ceil(filteredData.length / rowsPerPage) }, (_, i) => (
//                       <button
//                         key={i}
//                         onClick={() => setPage(i)}
//                         className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${page === i
//                           ? 'z-10 bg-blue-50 border-blue-500 text-blue-600'
//                           : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'
//                           }`}
//                       >
//                         {i + 1}
//                       </button>
//                     ))}
//                     <button
//                       onClick={() => setPage(Math.min(Math.ceil(filteredData.length / rowsPerPage) - 1, page + 1))}
//                       disabled={page >= Math.ceil(filteredData.length / rowsPerPage) - 1}
//                       className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
//                     >
//                       <span className="sr-only">Next</span>
//                       <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
//                         <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
//                       </svg>
//                     </button>
//                   </nav>
//                 </div>
//               </div>
//             </div> */}


//             <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between">

//               <div className="flex items-center">
//                 <p className="text-sm text-gray-700 mr-2">Rows per page:</p>
//                 <select
//                   className="border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none bg-white cursor-not-allowed"
//                   value={100}
//                   disabled
//                 >
//                   <option value={100}>100</option>
//                 </select>
//               </div>

//               <div className="flex items-center space-x-4">
//                 <button
//                   onClick={() => setPage(Math.max(0, page - 1))}
//                   disabled={page === 0}
//                   className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-white bg-black hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
//                 >
//                   Previous
//                 </button>
//                 <button
//                   onClick={() =>
//                     setPage(Math.min(Math.ceil(filteredData.length / 100) - 1, page + 1))
//                   }
//                   disabled={page >= Math.ceil(filteredData.length / 100) - 1}
//                   className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-white bg-black hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
//                 >
//                   Next
//                 </button>
//               </div>
//             </div>

//           </div>
//         )}
//       </div>
//     </div>
//   );
// };



const TicketDashboard = () => {
  const [ticketData, setTicketData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [orderBy, setOrderBy] = useState('showDate');
  const [order, setOrder] = useState('desc');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  const [dateOption, setDateOption] = useState('today');
  const [customRange, setCustomRange] = useState({ start: '', end: '' });
  const [theatreFilter, setTheatreFilter] = useState('');
  const [movieFilter, setMovieFilter] = useState('');
  const [showTimeFilter, setShowTimeFilter] = useState('');
  const [paymentMethodFilter, setPaymentMethodFilter] = useState('');
  // const [statusFilter, setStatusFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('COMPLETED');

  const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin"));
  const isTicketAdmin = role === 'ticket-admin';
  const theatreName = accessList?.[0];

  useEffect(() => {
    PaymentServices.getDetailReports1({ theatreName }).then(response => {

      console.log('data in the ticket dashboard====', response.data);
      // const items = response.data || [];

      
    

      const rawItems = response.data || [];
      const normalizedItems = rawItems.map(item => {
        const statusRaw = item.transactionStatus ? String(item.transactionStatus).toUpperCase() : '';
        const normalizedStatus = statusRaw === 'SUCCESS' ? 'COMPLETED' : statusRaw;

        return {
          ...item,
          transactionStatus: normalizedStatus
        };
      });
      // setTicketData(items);
      // setFilteredData(items);
      setTicketData(normalizedItems);
      setFilteredData(normalizedItems);
      setLoading(false);
    }).catch(err => {
      console.error('Error fetching ticket data:', err);
      setLoading(false);
    });
  }, []);


  const handleSort = (field) => {
    const isAsc = orderBy === field && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(field);
  };

  const sortedData = [...filteredData].sort((a, b) => {
    if (a[orderBy] < b[orderBy]) return order === 'asc' ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === 'asc' ? 1 : -1;
    return 0;
  });

  const paginatedData = sortedData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );






  const getDateRange = () => {
    const now = new Date();
    let start = new Date();
    let end = new Date();

    // Normalize times to beginning/end of day
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    switch (dateOption) {
      case 'yesterday':
        start.setDate(start.getDate() - 1);
        end.setDate(end.getDate() - 1);
        break;
      case 'week':
        start.setDate(start.getDate() - 7);
        break;
      case 'month':
        start.setDate(1); // First day of current month
        break;
      case 'year':
        start = new Date(now.getFullYear(), 0, 1); // First day of year
        break;
      case 'custom':
        return {
          start: customRange.start ? new Date(customRange.start) : null,
          end: customRange.end ? new Date(customRange.end) : null,
        };
      default: // 'today'
        break;
    }
    return { start, end };
  };

  useEffect(() => {
    let filtered = [...ticketData];
    const { start, end } = getDateRange();

    if (start && end) {
      filtered = filtered.filter(t => {
        try {
          const showDate = new Date(t.showDate);
          // console.log('showDate===============', showDate);
          // Normalize the show date to midnight for comparison
          const normalizedShowDate = new Date(showDate);
          normalizedShowDate.setHours(0, 0, 0, 0);

          const normalizedStart = new Date(start);
          normalizedStart.setHours(0, 0, 0, 0);

          const normalizedEnd = new Date(end);
          normalizedEnd.setHours(23, 59, 59, 999);

          return normalizedShowDate >= normalizedStart &&
            normalizedShowDate <= normalizedEnd;
        } catch (e) {
          console.error('Invalid date format', t.showDate);
          return false;
        }
      });
    }

    // Rest of your filters...
    if (theatreFilter) filtered = filtered.filter(t => t.theatreName === theatreFilter);
    if (movieFilter) filtered = filtered.filter(t => t.movieName === movieFilter);
    if (showTimeFilter) filtered = filtered.filter(t => t.showTime === showTimeFilter);
    if (paymentMethodFilter) filtered = filtered.filter(t => t.paymentMethod === paymentMethodFilter);
    if (statusFilter) filtered = filtered.filter(t => t.transactionStatus === statusFilter);

    setFilteredData(filtered);
    setPage(0);
  }, [ticketData, dateOption, customRange, theatreFilter, movieFilter, showTimeFilter, paymentMethodFilter, statusFilter]);



  // const exportCSV = () => {
  //   const headers = [
  //     'Movie', 'Theatre', 'Show Date', 'Show Time', 'Seats',
  //     'Amount', 'Payment Method', 'Payment Mode', 'Transaction ID',
  //     'PaymentStatus',
  //   ];
  //   const rows = ticketData.map(t => [
  //     t.movieName, t.theatreName, t.showDate, t.showTime,
  //     t.bookedSeats.join(', '), t.totalAmount, t.paymentMethod,
  //     t.paymentMode, t.transactionId, t.transactionStatus, t.bookingDate
  //   ]);
  //   const csv = [headers, ...rows].map(r => r.join(',')).join('\n');

  //   const blob = new Blob([csv], { type: 'text/csv' });
  //   const link = document.createElement('a');
  //   link.href = window.URL.createObjectURL(blob);
  //   link.download = 'TicketReport.csv';
  //   link.click();
  // };





  const exportCSV = () => {
    try {
      setLoading(true);

      // Use filteredData instead of ticketData
      const headers = [
        'Movie', 'Theatre', 'Show Date', 'Show Time', 'Seats',
        'Amount', 'Payment Method', 'Payment Mode', 'Transaction ID',
        'Payment Status', 'Booking Date'
      ];

      const rows = filteredData.map(ticket => [
        ticket.movieName || '',
        ticket.theatreName || '',
        formatDateToDDMMYYYY(ticket.showDate) || '',
        ticket.showTime || '',
        ticket.bookedSeats?.join(', ') || '',
        ticket.totalAmount || '0',
        // ticket.paymentMethod || '',
        ticket.paymentMethod === 'Cash' ? 'Counter' : ticket.paymentMethod || '',

        ticket.paymentMode || '',
        ticket.transactionId || '',
        ticket.transactionStatus || '',
        formatDateToDDMMYYYY(ticket.bookingDate) || ''
      ]);

      // Proper CSV formatting with escaped values
      const csvContent = [
        headers.join(','),
        ...rows.map(row =>
          row.map(field => `"${field.toString().replace(/"/g, '""')}"`).join(',')
        )
      ].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', `tickets_${new Date().toISOString().slice(0, 10)}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      console.error('Export failed:', error);
      // Add toast/notification here if available
    } finally {
      setLoading(false);
    }
  };




  // const getDateRange = () => {
  //   const now = new Date();
  //   let start = new Date();
  //   let end = new Date();
  //   switch (dateOption) {
  //     case 'yesterday':
  //       start.setDate(start.getDate() - 1);
  //       end.setDate(end.getDate() - 1);
  //       break;
  //     case 'week':
  //       start.setDate(start.getDate() - 7);
  //       break;
  //     case 'year':
  //       start.setFullYear(start.getFullYear() - 1);
  //       break;
  //     case 'custom':
  //       return {
  //         start: customRange.start ? new Date(customRange.start) : null,
  //         end: customRange.end ? new Date(customRange.end) : null,
  //       };
  //     default:
  //       break;
  //   }
  //   return { start, end };
  // };

  // useEffect(() => {
  //   let filtered = [...ticketData];
  //   const { start, end } = getDateRange();

  //   if (start && end) {
  //     filtered = filtered.filter(t => {
  //       const showDate = new Date(t.showDate);
  //       showDate.setHours(0, 0, 0, 0);
  //       return showDate >= new Date(start) && showDate <= new Date(end);
  //     });
  //   }

  //   if (theatreFilter) filtered = filtered.filter(t => t.theatreName === theatreFilter);
  //   if (movieFilter) filtered = filtered.filter(t => t.movieName === movieFilter);
  //   if (showTimeFilter) filtered = filtered.filter(t => t.showTime === showTimeFilter);
  //   if (paymentMethodFilter) filtered = filtered.filter(t => t.paymentMethod === paymentMethodFilter);
  //   if (statusFilter) filtered = filtered.filter(t => t.transactionStatus === statusFilter);

  //   setFilteredData(filtered);
  //   setPage(0);
  // }, [ticketData, dateOption, customRange, theatreFilter, movieFilter, showTimeFilter, paymentMethodFilter, statusFilter]);

  const getOptions = (field, base = filteredData) => {
    return [...new Set(base.map(t => t[field]))].filter(Boolean).sort();
  };

  const clearFilters = () => {
    setDateOption('today');
    setCustomRange({ start: '', end: '' });
    setTheatreFilter('');
    setMovieFilter('');
    setShowTimeFilter('');
    setPaymentMethodFilter('');
    setStatusFilter('COMPLETED'); // Change this from '' to 'COMPLETED'
  };

  const formatDateToDDMMYYYY = (dateInput) => {
    if (!dateInput) return '';
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
    if (isNaN(date.getTime())) return 'Invalid date';
    return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
  };

  const calculateMetrics = (data) => {

    console.log('data purchase cost', data[0]?.purchaseCost)
    if (data.length === 0) {
      return {
        totalTickets: 0,
        totalRevenue: 0,
        totalRevenue: 0,
        mostPopularShowTime: 'N/A',
        mostPopularMovie: 'N/A',
        filteredMovie: null,
        showTimeFilter: null // Add this
      };
    }

    const totalTickets = data.reduce((sum, ticket) => sum + ticket.bookedSeats.length, 0);
    const totalRevenue = data.reduce((sum, ticket) => sum + (ticket.totalAmount || 0), 0);



    const uniqueMovieTheatrePairs = new Map();

    data.forEach(ticket => {
      const key = `${ticket.movieName}-${ticket.theatreName}`;
      if (!uniqueMovieTheatrePairs.has(key) && ticket.purchaseCost) {
        uniqueMovieTheatrePairs.set(key, ticket.purchaseCost);
      }
    });

    const avgPaymentCost = [...uniqueMovieTheatrePairs.values()].reduce((sum, cost) => sum + cost, 0);



    // Check if we're filtering by a specific movie
    const uniqueMovies = [...new Set(data.map(item => item.movieName))];
    const filteredMovie = uniqueMovies.length === 1 ? uniqueMovies[0] : null;




    const showTimeCounts = data.reduce((acc, ticket) => {
      acc[ticket.showTime] = (acc[ticket.showTime] || 0) + ticket.bookedSeats.length;
      return acc;
    }, {});

    const mostPopularShowTime = Object.entries(showTimeCounts)
      .sort((a, b) => b[1] - a[1])[0]?.[0] || 'N/A';

    // Only calculate popular movie if not filtered by a specific movie
    let mostPopularMovie = 'N/A';
    if (!filteredMovie) {
      const movieCounts = data.reduce((acc, ticket) => {
        acc[ticket.movieName] = (acc[ticket.movieName] || 0) + ticket.bookedSeats.length;
        return acc;
      }, {});

      mostPopularMovie = Object.entries(movieCounts)
        .sort((a, b) => b[1] - a[1])[0]?.[0] || 'N/A';
    }

    return {
      totalTickets,
      totalRevenue,
      mostPopularShowTime,
      mostPopularMovie,
      filteredMovie,
      avgPaymentCost,
      showTimeFilter // Add this to the returned object
    };
  };



  const SummaryCards = ({ data }) => {
    const metrics = calculateMetrics(data);

    console.log('metrics', metrics)

    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6 py-2 px-1">
        {/* Total Payment Cost Card */}
        <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-blue-500">
          <div className="p-3 bg-blue-50 rounded-full">
            <img src={purchaseCost} alt='payment' className='w-10 h-10' />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Total Payment Cost</h3>
            <p className="text-2xl font-bold my-1 text-gray-800 truncate">
              ₹{typeof metrics.avgPaymentCost === 'number'
                ? metrics.avgPaymentCost.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : '0.00'}
            </p>
            <p className="text-gray-400 text-xs">Purchase cost of movie</p>
          </div>
        </div>

        {/* Total Tickets Card */}
        <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-green-500">
          <div className="p-3 bg-yellow-50 rounded-full">
            <img src={ticketicon} alt='tickets' className='w-10 h-10' />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Total Tickets</h3>
            <p className="text-2xl font-bold my-1 text-gray-800">{metrics.totalTickets}</p>
            <p className="text-gray-400 text-xs">Booked seats</p>
          </div>
        </div>

        {/* Total Revenue Card */}
        <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-purple-500">
          <div className="p-3 bg-blue-50 rounded-full">
            <img src={revenueicon} alt='revenue' className='w-10 h-10' />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Total Revenue</h3>
            <p className="text-2xl font-bold my-1 text-gray-800">
              ₹{metrics.totalRevenue.toLocaleString('en-IN')}
            </p>
            <p className="text-gray-400 text-xs">Total collected</p>
          </div>
        </div>

        {/* Popular Show Time Card */}
        {/* <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-yellow-500">
          <div className="p-3 bg-purple-50 rounded-full">
            <img src={showicon} alt='show' className='w-10 h-10' />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Popular Show</h3>
            <p className="text-2xl font-bold my-1 text-gray-800 truncate">
              {metrics.mostPopularShowTime || 'N/A'}
            </p>
            <p className="text-gray-400 text-xs">Most booked time</p>
          </div>
        </div> */}






        {metrics.showTimeFilter ? (
          <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-yellow-500">
            <div className="p-3 bg-purple-50 rounded-full">
              <img src={showicon} alt='show' className='w-10 h-10' />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Selected Show</h3>
              <p className="text-xl font-bold my-1 text-gray-800 truncate">
                {metrics.showTimeFilter}
              </p>
              <p className="text-gray-400 text-xs">Current filter</p>
            </div>
          </div>
        ) : (
          <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-yellow-500">
            <div className="p-3 bg-red-50 rounded-full">
              <img src={movieicon} alt='movie' className='w-10 h-10' />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Popular Show</h3>
              <p className="text-xl font-bold my-1 text-gray-800 truncate">
                {metrics.mostPopularShowTime}
              </p>
              <p className="text-gray-400 text-xs">Most booked time</p>
            </div>
          </div>
        )}

        {/* Movie Card (Conditional) */}
        {metrics.filteredMovie ? (
          <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-indigo-500">
            <div className="p-3 bg-red-50 rounded-full">
              <img src={movieicon} alt='movie' className='w-10 h-10' />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Selected Movie</h3>
              <p className="text-xl font-bold my-1 text-gray-800 truncate">
                {metrics.filteredMovie}
              </p>
              <p className="text-gray-400 text-xs">Current filter</p>
            </div>
          </div>
        ) : (
          <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 p-4 flex items-center gap-4 border-l-4 border-indigo-500">
            <div className="p-3 bg-red-50 rounded-full">
              <img src={movieicon} alt='movie' className='w-10 h-10' />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-gray-500 text-sm font-medium uppercase tracking-wider">Popular Movie</h3>
              <p className="text-xl font-bold my-1 text-gray-800 truncate">
                {metrics.mostPopularMovie || 'N/A'}
              </p>
              <p className="text-gray-400 text-xs">Most booked film</p>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="md:max-w-5xl mx-auto mb-4">
      <div className='mb-6'>
        {/* <h2 className="text-3xl font-semibold">Ticket Summary</h2> */}
        {/* Date Range Presets */}

        <div className="flex items-center gap-2 mb-4">
          <h2 className="text-3xl font-semibold">Ticket Summary</h2>
          <span className="text-xs font-semibold uppercase bg-gray-100 text-gray-700 px-2 py-1 rounded">
            V2
          </span>
        </div>





        {/* <div className="flex justify-between items-center mb-4 ">
          <h2 className="text-3xl font-semibold">Ticket Summary </h2>
          <button
            onClick={exportCSV}
            className="flex items-center bg-black text-white px-4 py-2 rounded hover:bg-gray-800 transition-colors"
          >
            <DownloadIcon className="h-5 w-5 mr-2" />
            Export CSV
          </button>
        </div> */}


        {/* Export Button - Right Aligned */}
        {/* <div className="flex items-center space-x-4">
         
          <button
            onClick={exportCSV}
            disabled={loading || filteredData.length === 0}
            className={`px-4 py-2 rounded-md transition-colors flex items-center gap-2 ${loading || filteredData.length === 0
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-green-600 hover:bg-green-700 text-white'
              }`}
          >
            {loading ? (
              <>
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Exporting...
              </>
            ) : (
              <>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
                Export to CSV
              </>
            )}
          </button>
        </div> */}











        <div className="bg-white rounded-lg shadow-md p-4 mb-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">Filter Tickets</h3>

          {/* Top Row Filters - Date Range and Payment Method */}
          <div className="flex flex-col sm:flex-row gap-4 mb-4">
            {/* Date Filter Section */}




            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Theatre</label>
              <select
                value={theatreFilter}
                onChange={e => setTheatreFilter(e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
              >
                <option value="">All Theatres</option>
                {getOptions('theatreName', ticketData).map(val => (
                  <option key={val} value={val}>{val}</option>
                ))}
              </select>
            </div>



            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">Date Range</label>
              <div className="flex flex-col sm:flex-row gap-2 items-start sm:items-center">
                <div className="relative w-full sm:w-40">
                  <select
                    value={dateOption}
                    onChange={(e) => setDateOption(e.target.value)}
                    className="w-full border border-gray-300 rounded-md px-3 py-2 pr-8 focus:outline-none focus:ring-2 focus:ring-gray-200 appearance-none"
                  >
                    <option value="today">Today</option>
                    <option value="yesterday">Yesterday</option>
                    <option value="week">Last 7 Days</option>
                    <option value="month">This Month</option>
                    <option value="year">This Year</option>
                    <option value="custom">Custom</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                </div>

                {/* Custom Date Range - Appears inline when 'custom' is selected */}
                {dateOption === 'custom' && (
                  <div className="flex items-center gap-2 w-full sm:w-auto">
                    <input
                      type="date"
                      value={customRange.start}
                      onChange={e => setCustomRange(prev => ({ ...prev, start: e.target.value }))}
                      className="w-full sm:w-36 border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
                    />
                    <span className="text-gray-500">to</span>
                    <input
                      type="date"
                      value={customRange.end}
                      onChange={e => setCustomRange(prev => ({ ...prev, end: e.target.value }))}
                      className="w-full sm:w-36 border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
                    />
                  </div>
                )}
              </div>
            </div>




          </div>

          {/* Bottom Row Filters - Theatre, Movie, Show Time, Status */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-4">
            {/* Theatre Dropdown */}
            {/* <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Theatre</label>
              <select
                value={theatreFilter}
                onChange={e => setTheatreFilter(e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
              >
                <option value="">All Theatres</option>
                {getOptions('theatreName', ticketData).map(val => (
                  <option key={val} value={val}>{val}</option>
                ))}
              </select>
            </div> */}



            {/* Movie Dropdown */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Movie</label>
              <select
                value={movieFilter}
                onChange={e => setMovieFilter(e.target.value)}
                disabled={!theatreFilter}
                className={`w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200 ${!theatreFilter ? 'bg-gray-100 text-gray-400' : ''
                  }`}
              >
                <option value="">All Movies</option>
                {getOptions('movieName', ticketData.filter(t => t.theatreName === theatreFilter)).map(val => (
                  <option key={val} value={val}>{val}</option>
                ))}
              </select>
            </div>

            {/* Show Time Dropdown */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Show Time</label>
              <select
                value={showTimeFilter}
                onChange={e => setShowTimeFilter(e.target.value)}
                disabled={!movieFilter}
                className={`w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200 ${!movieFilter ? 'bg-gray-100 text-gray-400' : ''
                  }`}
              >
                <option value="">All Show Times</option>
                {getOptions('showTime', ticketData.filter(t =>
                  t.theatreName === theatreFilter &&
                  t.movieName === movieFilter
                )).map(val => (
                  <option key={val} value={val}>{val}</option>
                ))}
              </select>
            </div>

            {/* Status Dropdown */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
              <select
                value={statusFilter}
                onChange={e => setStatusFilter(e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
              >
                <option value="">All Statuses</option>
                {getOptions('transactionStatus', ticketData).map(val => (
                  <option key={val} value={val}>{val}</option>
                ))}
              </select>
            </div>

            {/* Payment Method - Moved up beside Date Range */}

            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">Payment Method</label>
              <select
                value={paymentMethodFilter}
                onChange={e => setPaymentMethodFilter(e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-200"
              >
                <option value="">All Methods</option>
                {/* {getOptions('paymentMethod', ticketData).map(val => (
                  <option key={val} value={val}>{val}</option>
                ))} */}

                {getOptions('paymentMethod', ticketData).map(val => (
                  <option key={val} value={val}>
                    {val === 'Cash' ? 'Counter' : val}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Clear Filters Button */}
          {/* <button
            onClick={clearFilters}
            className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors flex items-center justify-center gap-2 w-full sm:w-auto"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
            Clear All Filters
          </button>


          <button
            onClick={exportCSV}
            className="flex items-center bg-black text-white px-4 py-2 rounded hover:bg-gray-800 transition-colors"
          >
            <DownloadIcon className="h-5 w-5 mr-2" />
            Generate Report
          </button> */}

          <div className="flex flex-wrap gap-2 mt-4">
            {/* Clear Filters Button */}
            <button
              onClick={clearFilters}
              className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors flex items-center justify-center gap-2 flex-1 sm:flex-none"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              Clear All Filters
            </button>

            {/* Export CSV Button */}
            <button
              onClick={exportCSV}
              disabled={loading || filteredData.length === 0}
              className={`px-4 py-2 rounded-md transition-colors flex items-center justify-center gap-2 flex-1 sm:flex-none ${loading || filteredData.length === 0
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-black hover:bg-gray-800 text-white'
                }`}
            >
              {loading ? (
                <>
                  <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Exporting...
                </>
              ) : (
                <>
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                  Generate Report
                </>
              )}
            </button>
          </div>

        </div>


        {/* <div className="my-2 flex gap-2 flex-wrap">
          {["today", "yesterday", "week", "year", "custom"].map(opt => (
            <button
              key={opt}
              onClick={() => setDateOption(opt)}
              className={`px-3 py-1 rounded ${dateOption === opt ? 'bg-black text-white' : 'bg-gray-100 text-black'}`}
            >
              {opt.toUpperCase()}
            </button>
          ))}
        </div> */}
        {/* {dateOption === 'custom' && (
          <div className="flex gap-2">
            <input type="date" value={customRange.start} onChange={e => setCustomRange(prev => ({ ...prev, start: e.target.value }))} />
            <input type="date" value={customRange.end} onChange={e => setCustomRange(prev => ({ ...prev, end: e.target.value }))} />
          </div>
        )} */}

        {/* Filter Section */}
        {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 my-4">
          <select value={theatreFilter} onChange={e => setTheatreFilter(e.target.value)}>
            <option value="">Select Theatre</option>
            {getOptions('theatreName', ticketData).map(val => <option key={val} value={val}>{val}</option>)}
          </select>
          <select value={movieFilter} onChange={e => setMovieFilter(e.target.value)} disabled={!theatreFilter}>
            <option value="">Select Movie</option>
            {getOptions('movieName', ticketData.filter(t => t.theatreName === theatreFilter)).map(val => <option key={val} value={val}>{val}</option>)}
          </select>
          <select value={showTimeFilter} onChange={e => setShowTimeFilter(e.target.value)} disabled={!movieFilter}>
            <option value="">Select Show Time</option>
            {getOptions('showTime', ticketData.filter(t => t.theatreName === theatreFilter && t.movieName === movieFilter)).map(val => <option key={val} value={val}>{val}</option>)}
          </select>
          <select value={paymentMethodFilter} onChange={e => setPaymentMethodFilter(e.target.value)}>
            <option value="">Payment Method</option>
            {getOptions('paymentMethod').map(val => <option key={val} value={val}>{val}</option>)}
          </select>
          <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
            <option value="">Status</option>
            {getOptions('transactionStatus').map(val => <option key={val} value={val}>{val}</option>)}
          </select>
        </div>
        <button className="bg-red-500 text-white px-4 py-2 rounded" onClick={clearFilters}>Clear All Filters</button> */}
      </div>
      {!loading && filteredData.length > 0 && (
        <SummaryCards data={filteredData} />
      )}



      {/* Results Section */}
      {loading ? (
        <div className="flex justify-center items-center h-24">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-black"></div>
        </div>
      ) : filteredData.length === 0 ? (
        <div className="text-center py-12">
          <div className="mx-auto h-24 w-24 text-gray-400">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h3 className="mt-2 text-lg font-medium text-gray-700">No tickets found</h3>
          <p className="mt-1 text-gray-500">Try adjusting your search or filter criteria</p>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-black">
                <tr>
                  {[
                    // { label: 'Booking Date', field: 'bookingDate' },
                    { label: 'Show Date', field: 'showDate' },
                    { label: 'Show Time', field: 'showTime' },
                    { label: 'Movie', field: 'movieName' },
                    { label: 'Theatre', field: 'theatreName' },
                    { label: 'Seats', field: 'bookedSeats' },

                    { label: 'Amount', field: 'totalAmount' },
                    { label: 'Payment Method', field: 'paymentMethod' },
                    { label: 'Payment Mode', field: 'paymentMode' },
                    { label: 'Transaction ID', field: 'transactionId' },
                    { label: 'Status', field: 'transactionStatus' },
                  ].map((col) => (
                    <th
                      key={col.field}
                      scope="col"
                      className="px-6 py-4 text-left text-xs font-semibold text-gray-100 uppercase tracking-wider cursor-pointer hover:bg-gray-700 transition-colors duration-150"
                      onClick={() => handleSort(col.field)}
                    >
                      <div className="flex items-center">
                        {col.label}
                        {orderBy === col.field && (
                          <span className="ml-2">
                            {order === 'asc' ? (
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                              </svg>
                            ) : (
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                              </svg>
                            )}
                          </span>
                        )}
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody className="bg-white divide-y divide-gray-200">
                {paginatedData.map((t, idx) => (
                  <tr key={idx} className="hover:bg-gray-50 transition-colors duration-150">
                    {/* <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {formatDateToDDMMYYYY(t.bookingDate)}
                    </td> */}
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                      {formatDateToDDMMYYYY(t.showDate)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                      <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded-full text-xs font-medium">
                        {t.showTime}
                        {/* {t.showTime} */}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-900">
                      {t.movieName}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                      {t.theatreName}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                      <div className="flex flex-wrap gap-1 max-w-xs">
                        {t.bookedSeats.map((seat, i) => (
                          <span key={i} className="px-2 py-1 bg-gray-100 text-gray-800 rounded text-xs">
                            {seat}
                          </span>
                        ))}
                      </div>
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap text-sm font-semibold text-green-600">
                      ₹{t.totalAmount}
                    </td>
                    {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                      {t.paymentMethod}
                    </td> */}
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                      {t.paymentMethod === 'Cash' ? 'Counter' : t.paymentMethod || ''}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                 
                      {t.paymentMode}
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600 font-mono">
                      {t.transactionId}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${t.transactionStatus?.toLowerCase() === 'success' || t.transactionStatus?.toLowerCase() === 'completed'
                        ? 'bg-green-100 text-green-800'
                        : t.transactionStatus?.toLowerCase() === 'pending'
                          ? 'bg-yellow-100 text-yellow-800'
                          : 'bg-red-100 text-red-800'
                        }`}>
                             {t.transactionStatus?.toLowerCase() === 'success' ? 'COMPLETED' : t.transactionStatus || ''}
                        {/* {t.transactionStatus} */}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {/* <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between">
              <div className="flex-1 flex justify-between sm:hidden">
                <button
                  onClick={() => setPage(Math.max(0, page - 1))}
                  disabled={page === 0}
                  className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Previous
                </button>
                <button
                  onClick={() => setPage(Math.min(Math.ceil(filteredData.length / rowsPerPage) - 1, page + 1))}
                  disabled={page >= Math.ceil(filteredData.length / rowsPerPage) - 1}
                  className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Next
                </button>
              </div>
              <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                <div>
                  <p className="text-sm text-gray-700">
                    Showing <span className="font-medium">{page * rowsPerPage + 1}</span> to{' '}
                    <span className="font-medium">
                      {Math.min((page + 1) * rowsPerPage, filteredData.length)}
                    </span>{' '}
                    of <span className="font-medium">{filteredData.length}</span> results
                  </p>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="flex items-center">
                    <p className="text-sm text-gray-700 mr-2">Rows per page:</p>
                    <select
                      className="border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      value={rowsPerPage}
                      onChange={(e) => {
                        setRowsPerPage(parseInt(e.target.value, 10));
                        setPage(0);
                      }}
                    >
                      {[100, 200].map((size) => (
                        <option key={size} value={size}>
                          {size}
                        </option>
                      ))}
                    </select>
                  </div>
                  <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                    <button
                      onClick={() => setPage(Math.max(0, page - 1))}
                      disabled={page === 0}
                      className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <span className="sr-only">Previous</span>
                      <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </button>
                    {Array.from({ length: Math.ceil(filteredData.length / rowsPerPage) }, (_, i) => (
                      <button
                        key={i}
                        onClick={() => setPage(i)}
                        className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${page === i
                          ? 'z-10 bg-blue-50 border-blue-500 text-blue-600'
                          : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'
                          }`}
                      >
                        {i + 1}
                      </button>
                    ))}
                    <button
                      onClick={() => setPage(Math.min(Math.ceil(filteredData.length / rowsPerPage) - 1, page + 1))}
                      disabled={page >= Math.ceil(filteredData.length / rowsPerPage) - 1}
                      className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <span className="sr-only">Next</span>
                      <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                      </svg>
                    </button>
                  </nav>
                </div>
              </div>
            </div> */}


          <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between">

            <div className="flex items-center">
              <p className="text-sm text-gray-700 mr-2">Rows per page:</p>
              <select
                className="border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none bg-white cursor-not-allowed"
                value={100}
                disabled
              >
                <option value={100}>100</option>
              </select>
            </div>

            <div className="flex items-center space-x-4">
              <button
                onClick={() => setPage(Math.max(0, page - 1))}
                disabled={page === 0}
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-white bg-black hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Previous
              </button>
              <button
                onClick={() =>
                  setPage(Math.min(Math.ceil(filteredData.length / 100) - 1, page + 1))
                }
                disabled={page >= Math.ceil(filteredData.length / 100) - 1}
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-white bg-black hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Next
              </button>
            </div>
          </div>

        </div>
      )}


      {/* Keep existing SummaryCards and table rendering logic here */}
    </div>
  );
};












export default TicketDashboard;

